import type { CaseExercise } from "../types";

// Case Gym Ausbau (BGB-AT), 2 neue Fälle. Von Vincent freigegeben (2026-06-03,
// question-reviewer-Gate 6 Schritte OK / 0 FIX / 0 AMBIG) -> reviewStatus "beta-ready".
// Struktur exakt wie src/data/cases.ts; in den cases-Array gespreadet.
export const caseGymExtra: CaseExercise[] = [
  {
    id: "case-verjaehrung-werklohn",
    pathId: "hagen-jura",
    topic: "BGB AT - Verjährung",
    title: "Die vergessene Werklohnforderung",
    level: "Anwendbar",
    levelNumber: 3,
    skillTags: ["bgb-at", "subsumtion", "verjaehrung"],
    reviewStatus: "beta-ready",
    sachverhalt:
      "Handwerker H führt im Mai 2021 eine Reparatur für Kunde K aus und rechnet ordnungsgemäß 800 Euro ab. K zahlt nicht. H denkt erst Anfang 2025 wieder an die offene Forderung und will sie nun gerichtlich durchsetzen.",
    steps: [
      {
        question: "Welche Verjährungsfrist gilt für die Werklohnforderung des H?",
        correct: ["Die regelmäßige Verjährungsfrist von drei Jahren (§ 195 BGB)"],
        distractors: {
          einfach: [
            "Dreißig Jahre",
            "Sechs Monate",
            "Geldforderungen verjähren überhaupt nicht",
          ],
          medium: [
            "Zehn Jahre",
            "Zwei Jahre wie bei kaufrechtlichen Mängelansprüchen",
            "Fünf Jahre",
          ],
          schwer: [
            "Vier Jahre nach der früheren Sonderregel für Handwerkerleistungen (§ 196 a.F.)",
            "Zwei Jahre nach § 438 Abs. 1 Nr. 3 BGB",
            "Dreißig Jahre, weil es um eine Reparatur an einer Sache geht",
          ],
          "sehr-schwer": [
            "Drei Jahre, jedoch taggenau ab Fälligkeit gerechnet (§ 200 BGB)",
            "Zehn Jahre als absolute Höchstfrist nach § 199 Abs. 4 BGB",
            "Dreißig Jahre nach § 197 Abs. 1 Nr. 3 BGB, da rechtskräftig festgestellte Ansprüche so verjähren",
          ],
        },
        explanation:
          "§ 195 BGB: Die regelmäßige Verjährungsfrist beträgt drei Jahre. Die Werklohnforderung unterfällt keiner Sonderfrist (§§ 196 Grundstücke, 197 u.a. titulierte Ansprüche). Die frühere vierjährige Handwerkerfrist (§ 196 a.F.) wurde mit der Schuldrechtsreform 2002 abgeschafft; § 199 Abs. 4 (10 Jahre) und § 197 (30 Jahre) betreffen andere Konstellationen.",
        sources: [{ id: "bgb195", label: "§ 195 BGB", url: "https://www.gesetze-im-internet.de/bgb/__195.html" }],
      },
      {
        question: "Wann beginnt diese regelmäßige Verjährungsfrist?",
        correct: [
          "Mit dem Schluss des Jahres, in dem der Anspruch entstand und H von den anspruchsbegründenden Umständen Kenntnis erlangte (§ 199 Abs. 1 BGB)",
        ],
        distractors: {
          einfach: [
            "Mit dem Tag des Vertragsschlusses",
            "Mit der Klageerhebung",
            "Mit der ersten Mahnung",
          ],
          medium: [
            "Mit dem Tag der Fälligkeit der Forderung",
            "Mit dem Schluss des Monats, in dem die Forderung entstand",
            "Mit der Ausstellung der Rechnung",
          ],
          schwer: [
            "Taggenau mit Entstehung des Anspruchs nach § 200 BGB",
            "Mit Kenntnis, aber sofort und nicht erst zum Jahresschluss",
            "Mit dem Schluss des Jahres der Fälligkeit, ohne dass es auf Kenntnis ankäme",
          ],
          "sehr-schwer": [
            "Mit dem Schluss des Jahres der Entstehung; auf die Kenntnis kommt es nur bei Schadensersatzansprüchen an",
            "Kenntnisunabhängig nach § 200 BGB, da § 199 nur Sonderfälle regelt",
            "Mit dem Schluss des Jahres der Kenntnis, frühestens jedoch mit Rechtskraft eines Mahnbescheids",
          ],
        },
        explanation:
          "§ 199 Abs. 1 BGB: Die regelmäßige Frist beginnt mit dem Schluss des Jahres, in dem (1) der Anspruch entstanden ist und (2) der Gläubiger von den anspruchsbegründenden Umständen und der Person des Schuldners Kenntnis erlangt oder ohne grobe Fahrlässigkeit erlangen müsste. Hier: Entstehung + Kenntnis 2021 → Beginn 31.12.2021, Ablauf 31.12.2024. § 200 (taggenauer Beginn) gilt nur für Ansprüche ohne § 199-Voraussetzungen.",
        sources: [{ id: "bgb199", label: "§ 199 BGB", url: "https://www.gesetze-im-internet.de/bgb/__199.html" }],
      },
      {
        question: "K erhebt die Einrede der Verjährung. Welche Wirkung hat die Verjährung auf H's Anspruch?",
        correct: [
          "Der Anspruch erlischt nicht; K erhält ein dauerndes Leistungsverweigerungsrecht (Einrede), § 214 Abs. 1 BGB",
        ],
        distractors: {
          einfach: [
            "Der Anspruch erlischt automatisch mit Fristablauf",
            "Der Anspruch wird halbiert",
            "Die Forderung geht auf den Staat über",
          ],
          medium: [
            "Der Anspruch erlischt und ist vom Gericht von Amts wegen zu beachten",
            "Der Anspruch besteht fort und bleibt trotz Einrede voll durchsetzbar",
            "Die Verjährung wirkt nur, wenn sie notariell erklärt wird",
          ],
          schwer: [
            "Die Verjährung vernichtet den Anspruch rückwirkend (ex tunc)",
            "Das Gericht weist die Klage von Amts wegen ab, auch ohne dass K die Einrede erhebt",
            "Der Anspruch wird zur Naturalobligation und kann auch nicht mehr wirksam erfüllt werden",
          ],
          "sehr-schwer": [
            "Der Anspruch bleibt bestehen, das Gericht muss die Verjährung aber von Amts wegen prüfen",
            "K kann die Leistung verweigern; zahlt er dennoch in Unkenntnis der Verjährung, kann er das Geleistete nach § 813 BGB zurückfordern",
            "Der Anspruch erlischt; eine dennoch erbrachte Leistung ist aber nach § 814 BGB nicht rückforderbar",
          ],
        },
        explanation:
          "§ 214 Abs. 1 BGB: Nach Eintritt der Verjährung ist der Schuldner berechtigt, die Leistung zu verweigern (peremptorische Einrede) — der Anspruch erlischt NICHT, ist aber nicht mehr durchsetzbar. Die Verjährung wird nur auf Einrede beachtet, nie von Amts wegen. § 214 Abs. 2: Zur Erfüllung eines verjährten Anspruchs Geleistetes kann nicht zurückgefordert werden, auch nicht in Unkenntnis der Verjährung (Sonderregel, nicht § 813/§ 814).",
        sources: [{ id: "bgb214", label: "§ 214 BGB", url: "https://www.gesetze-im-internet.de/bgb/__214.html" }],
      },
    ],
  },
  {
    id: "case-bedingung-autokauf",
    pathId: "hagen-jura",
    topic: "BGB AT - Bedingung",
    title: "Autokauf unter Finanzierungsvorbehalt",
    level: "Anwendbar",
    levelNumber: 3,
    skillTags: ["bgb-at", "subsumtion", "bedingung"],
    reviewStatus: "beta-ready",
    sachverhalt:
      "V verkauft K seinen gebrauchten Pkw. Beide vereinbaren ausdrücklich, dass der Kaufvertrag nur gelten soll, wenn K bis zum 30. des Monats die Finanzierungszusage seiner Bank erhält.",
    steps: [
      {
        question: "Welche Art von Bedingung haben V und K vereinbart?",
        correct: ["Eine aufschiebende Bedingung (§ 158 Abs. 1 BGB)"],
        distractors: {
          einfach: [
            "Eine auflösende Bedingung (§ 158 Abs. 2 BGB)",
            "Eine bloße Befristung (§ 163 BGB)",
            "Gar keine Bedingung, nur ein unbeachtliches Motiv",
          ],
          medium: [
            "Eine auflösende Bedingung, da der Vertrag bei Ausbleiben der Zusage endet",
            "Eine Rechtsbedingung (condicio iuris)",
            "Eine Potestativbedingung, die stets unwirksam ist",
          ],
          schwer: [
            "Eine auflösende Bedingung, weil die Wirksamkeit zunächst eintritt und später entfallen kann",
            "Eine unzulässige Bedingung, da der Kaufvertrag bedingungsfeindlich ist",
            "Eine bloße Geschäftsgrundlage im Sinne des § 313 BGB",
          ],
          "sehr-schwer": [
            "Eine aufschiebende Bedingung, deren Wirkung nach § 158 auf den Zeitpunkt des Vertragsschlusses zurückwirkt",
            "Eine aufschiebende Bedingung; bis zum Eintritt ist der Vertrag schwebend unwirksam wie im Fall des § 177 BGB",
            "Eine aufschiebende Bedingung, die hier jedoch wegen § 925 Abs. 2 BGB unzulässig ist",
          ],
        },
        explanation:
          "§ 158 Abs. 1 BGB: Bei der aufschiebenden Bedingung tritt die abhängige Wirkung erst mit Bedingungseintritt ein — hier soll der Kaufvertrag erst mit der Finanzierungszusage gelten. Schuldrechtliche Verträge sind bedingungsfreundlich (anders die Auflassung, § 925 Abs. 2). Eine Rückwirkung auf den Vertragsschluss tritt nicht ein; der Schwebezustand ist nicht mit der schwebenden Unwirksamkeit des § 177 (Vertreter ohne Vertretungsmacht) gleichzusetzen.",
        sources: [{ id: "bgb158", label: "§ 158 BGB", url: "https://www.gesetze-im-internet.de/bgb/__158.html" }],
      },
      {
        question:
          "K erhält die Finanzierungszusage nicht, weil V die dafür nötige Auskunft treuwidrig verweigert, um aus dem Vertrag herauszukommen. Was gilt?",
        correct: ["Die Bedingung gilt als eingetreten, weil V ihren Eintritt treuwidrig verhindert hat (§ 162 Abs. 1 BGB)"],
        distractors: {
          einfach: [
            "Der Vertrag ist endgültig unwirksam, da die Bedingung ausgefallen ist",
            "V muss nur Schadensersatz zahlen, der Vertrag bleibt unwirksam",
            "K muss mit V eine neue Bedingung vereinbaren",
          ],
          medium: [
            "Die Bedingung ist ausgefallen; K kann nur nach § 280 BGB Schadensersatz verlangen",
            "Der Vertrag wird schwebend unwirksam, bis V zustimmt",
            "K kann den Vertrag nach § 123 BGB anfechten",
          ],
          schwer: [
            "Die Bedingung gilt als ausgefallen, weil ihr Eintritt objektiv unmöglich geworden ist",
            "§ 162 gilt nur für auflösende Bedingungen, daher bleibt es beim Ausfall",
            "Es gilt § 815 BGB, K kann nur Wertersatz verlangen",
          ],
          "sehr-schwer": [
            "Die Bedingung gilt als eingetreten, jedoch nur, wenn V vorsätzlich handelte; bloße Fahrlässigkeit genügt für § 162 nicht",
            "Die Bedingung gilt als eingetreten; V kann sich aber seinerseits auf § 242 BGB berufen, um die Wirkung abzuwenden",
            "§ 162 fingiert den Eintritt nur für Schadensersatzzwecke, nicht für die Wirksamkeit des Vertrags",
          ],
        },
        explanation:
          "§ 162 Abs. 1 BGB: Wird der Eintritt der Bedingung von der Partei, zu deren Nachteil er gereichen würde, wider Treu und Glauben verhindert, gilt die Bedingung als eingetreten. V kann sich nicht auf den von ihm treuwidrig herbeigeführten Ausfall berufen; der Kaufvertrag wird wirksam. Maßgeblich ist treuwidriges Verhalten (nicht nur Vorsatz), und die Fiktion wirkt für die Vertragswirksamkeit selbst, nicht bloß für Schadensersatz.",
        sources: [{ id: "bgb162", label: "§ 162 BGB", url: "https://www.gesetze-im-internet.de/bgb/__162.html" }],
      },
      {
        question: "Angenommen, die Bedingung tritt regulär ein (K erhält die Zusage). Ab wann ist der Kaufvertrag wirksam?",
        correct: [
          "Mit dem Eintritt der Bedingung (ex nunc); eine Rückwirkung auf den Vertragsschluss tritt nicht ein (§ 158 Abs. 1 BGB)",
        ],
        distractors: {
          einfach: [
            "Rückwirkend ab dem Tag des Vertragsschlusses",
            "Erst mit der Übergabe des Pkw",
            "Erst nach gerichtlicher Bestätigung",
          ],
          medium: [
            "Rückwirkend auf den Vertragsschluss, da Bedingungen stets ex tunc wirken",
            "Mit der Zahlung des Kaufpreises",
            "Mit Ablauf einer 14-tägigen Widerrufsfrist",
          ],
          schwer: [
            "Rückwirkend nach § 159 BGB, da diese Norm eine dingliche Rückwirkung anordnet",
            "Erst mit einer erneuten Willenseinigung der Parteien nach Bedingungseintritt",
            "Mit Eintritt der Bedingung, jedoch nur, wenn V erneut zustimmt",
          ],
          "sehr-schwer": [
            "Mit Eintritt der Bedingung; § 159 BGB bezieht die Wirkung jedoch im Zweifel dinglich auf den Vertragsschluss zurück",
            "Mit Eintritt der Bedingung, für die Verjährung aber rückwirkend ab Vertragsschluss",
            "Rückwirkend, weil die Parteien gerade eine aufschiebende (nicht auflösende) Bedingung gewählt haben",
          ],
        },
        explanation:
          "§ 158 Abs. 1 BGB: Die Wirkung tritt mit dem Bedingungseintritt ein (ex nunc), nicht rückwirkend. § 159 BGB betrifft nur den Fall, dass die Parteien einander schuldrechtlich so stellen wollen, als sei die Wirkung früher eingetreten — er ordnet keine echte (dingliche) Rückwirkung an. Auch die Verjährung beginnt nicht vor Wirksamkeit/Entstehung des Anspruchs.",
        sources: [{ id: "bgb158", label: "§ 158 BGB", url: "https://www.gesetze-im-internet.de/bgb/__158.html" }],
      },
    ],
  },
];
